export default "__VITE_ASSET__CEFUNe1x__"